<p class="header-link">
  <button
    (click)="isMyndighedKontaktModalOpen$.next(true)"
    class="button button-quaternary button-contact pr-3"
    data-micromodal-trigger="modal-contact"
  >
    {{ title }}
    <svg class="icon-svg"><use xlink:href="#menu-right"></use></svg>
  </button>
</p>
<bom-modal
  [title]="'Kontakt' | tekstresource"
  [isOpen$]="isMyndighedKontaktModalOpen$"
  [minWidthPx]="800"
>
  <ng-container bom-modal-header><bom-save-indicator></bom-save-indicator></ng-container>
  <ng-container bom-modal-content>
    <p><span [innerHTML]="'MyndighedContact.Modal.DefaultHtml.Line1' | tekstresource"></span></p>
    <br />
    <p>
      <span [innerHTML]="'MyndighedContact.Modal.DefaultHtml.Line2' | tekstresource"></span>
      <a
        [routerLink]="['/hjaelp', 'myndighedsinformation']"
        (click)="isMyndighedKontaktModalOpen$.next(false)"
        >her</a
      >
    </p>
  </ng-container>
  <ng-container bom-modal-footer> </ng-container>
</bom-modal>
